import { render, staticRenderFns } from "./add-edit-topic.vue?vue&type=template&id=fd5bcc24&scoped=true&"
import script from "./add-edit-topic.vue?vue&type=script&lang=js&"
export * from "./add-edit-topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5bcc24",
  null
  
)

export default component.exports